module.exports = __webpack_public_path__ + "static/ricks-ranchwear-logo-8fccf9d3c8baf1f0189ba3a4c4886262.svg";